import { render, staticRenderFns } from "./MajorShareholdersDetails.vue?vue&type=template&id=490a914b"
import script from "./MajorShareholdersDetails.vue?vue&type=script&lang=js"
export * from "./MajorShareholdersDetails.vue?vue&type=script&lang=js"
import style0 from "./MajorShareholdersDetails.vue?vue&type=style&index=0&id=490a914b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports